var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoon = function SvgMoon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.43.42a1 1 0 0 1 .038 1.103A9.95 9.95 0 0 0 9 6.74c0 4.74 3.299 8.711 7.726 9.74a1 1 0 1 1-.452 1.948C10.96 17.196 7 12.432 7 6.742c0-1.412.244-2.769.693-4.028A10 10 0 0 0 2 11.74c0 5.523 4.477 10 10 10a9.99 9.99 0 0 0 8.532-4.782 1 1 0 0 1 1.706 1.045A11.99 11.99 0 0 1 12 23.741c-6.627 0-12-5.373-12-12C0 6.006 4.022 1.212 9.4.024a1 1 0 0 1 1.03.396",
    clipRule: "evenodd"
  })));
};
export default SvgMoon;